.wrapper {
  position: absolute;
  top: 0;
  right: 0;
}

.button {
  width: 24px;
  height: 24px;
}

.button:hover {
  transform: scale(1.2);
}

.button-solid {
  opacity: 1 !important;
}

.label {
  color: var(--rds-foreground-primary);
}

.input {
  height: 100%;
  width: 100%;
  cursor: pointer;
}
